import React from 'react';
import { useNavigate } from 'react-router-dom';

const TermsOfService = () => {
  const navigate = useNavigate();

  const handleRetornar = () => {
    navigate('/login');
  };

  return (
    <div className="bg-light min-vh-100 py-5">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12 col-lg-10">

            <div className="card shadow-sm border-0">
              <div className="card-body p-4 p-md-5">

                {/* Cabeçalho com Badge de Status */}
                <header className="mb-5 text-center">
                  <div className="mb-3">
                    <span className="badge rounded-pill bg-warning text-dark px-3 py-2 shadow-sm">
                      <i className="bi bi-exclamation-triangle-fill me-2"></i>
                      AMBIENTE BETA: TESTES EM CURSO
                    </span>
                  </div>
                  <h4 className="text-muted fw-light">PhantomTech Technology</h4>
                  <h1 className="display-5 fw-bold text-primary">Termos de Uso e Privacidade</h1>
                  <hr className="w-25 mx-auto border-primary border-2 opacity-75" />
                </header>

                <section className="text-secondary lh-lg">
                  {/* Alerta LGPD e Beta */}
                  <div className="alert alert-info border-0 shadow-sm my-4">
                    <p className="fw-bold mb-1"><i className="bi bi-info-circle-fill me-2"></i>AVISO DE PARTICIPAÇÃO BETA:</p>
                    <p className="small mb-0">
                      Ao utilizar esta aplicação, você compreende que se trata de uma versão experimental.
                      <strong> Não há garantias de funcionamento ininterrupto, entrega de valor comercial ou promessa de licenciamento futuro.</strong>
                    </p>
                  </div>

                  <h3 className="h4 mt-5 mb-3 text-dark fw-bold border-start border-4 border-primary ps-3">1. Natureza do Teste</h3>
                  <p>
                    O usuário aceita atuar como <strong>Beta-Tester</strong> voluntário. A PhantomTech fornece acesso à ferramenta no estado em que se encontra ("as is"), visando identificar falhas e coletar métricas de desempenho. O acesso é precário e pode ser revogado a qualquer momento sem aviso prévio.
                  </p>

                  <h3 className="h4 mt-5 mb-3 text-dark fw-bold border-start border-4 border-primary ps-3">2. Coleta de Dados e LGPD</h3>
                  <p>
                    Para aprimorar a ferramenta, realizamos uma coleta robusta de dados em conformidade com a <strong>Lei Geral de Proteção de Dados (LGPD)</strong>:
                  </p>
                  <ul className="list-group list-group-flush mb-4">
                    <li className="list-group-item bg-transparent"><strong>Identificação:</strong> Nome, e-mail, CPF, Data de Nascimento e credenciais de acesso para proporcionar a gestão de conta pelo usuário em alto nível de segurança.</li>
                    <li className="list-group-item bg-transparent"><strong>Dados de Diagnóstico:</strong> Logs de erros, tempo de resposta e interações com a interface.</li>
                    <li className="list-group-item bg-transparent"><strong>Métricas Técnicas:</strong> Endereço IP, tipo de navegador e dados de geolocalização aproximada para fins de Analytics e/ou para possibilitar execução de políticas de segurança, visando proteção da aplicação e de todos os seus dados.</li>
                  </ul>

                  <h3 className="h4 mt-5 mb-3 text-dark fw-bold border-start border-4 border-primary ps-3">3. Propriedade Intelectual e Feedback</h3>
                  <p>
                    Todo e qualquer feedback, relatório de erro ou sugestão enviado à PhantomTech torna-se propriedade desta, podendo ser utilizado para aprimoramento do produto sem que isso gere direitos a compensações ou participação na propriedade intelectual ao testador.
                  </p>

                  <h3 className="h4 mt-5 mb-3 text-dark fw-bold border-start border-4 border-primary ps-3">4. Confidencialidade</h3>
                  <p>
                    Como participante do programa beta, você se compromete a não divulgar publicamente capturas de tela, detalhes técnicos ou falhas de segurança encontradas sem a autorização expressa e por escrito da equipe de desenvolvimento.
                  </p>

                  <h3 className="h4 mt-5 mb-3 text-dark fw-bold border-start border-4 border-primary ps-3">5. Propriedade Intelectual</h3>
                  <p>
                    Todo o conteúdo desta aplicação — incluindo o código-fonte, a lógica de negócio, as interfaces visuais e a própria <strong>ideia de solução tecnológica</strong> — é de propriedade exclusiva da <strong>PhantomTech Technology</strong>, nome-fantasia do projeto e/ou de seu Desenvolvedor.
                  </p>
                  <p className="bg-white p-3 border rounded shadow-sm">
                    O acesso como Beta-Tester não transfere qualquer direito de propriedade ou licença comercial. É estritamente proibida a reprodução, engenharia reversa ou cópia de funcionalidades, sob pena das sanções previstas na Lei de Propriedade Industrial e na Lei de Software.
                  </p>

                  <h3 className="h4 mt-5 mb-3 text-dark fw-bold border-start border-4 border-primary ps-3">6. Seus Direitos</h3>
                  <p>
                    Você pode solicitar a qualquer momento a confirmação da existência de tratamento, o acesso aos seus dados ou a <strong>exclusão definitiva</strong> de seu perfil beta através de nossos canais oficiais.
                  </p>

                  {/* Canais de Contato */}
                  <div className="bg-white border rounded p-4 mt-5 shadow-sm">
                    <h5 className="text-dark fw-bold mb-3">Canais de Contato Oficiais</h5>
                    <ul className="list-unstyled mb-0">
                      <li className="mb-2">
                        <i className="bi bi-whatsapp text-success me-2"></i>
                        <strong>Suporte Beta:</strong> <a href="https://wa.me/5521999999999" className="text-decoration-none">+55 21 99999-9999</a>
                      </li>
                      <li className="mb-2">
                        <i className="bi bi-envelope-at text-primary me-2"></i>
                        <strong>E-mail:</strong> <a href="mailto:webmaster@phantomtech.com.br" className="text-decoration-none">webmaster@phantomtech.com.br</a>
                      </li>
                    </ul>
                  </div>

                  <p className="text-muted small mt-5 italic text-center">
                    Versão Beta 1.0.2 | Atualizado em: Rio de Janeiro-RJ, 16 de fevereiro de 2025.
                  </p>
                </section>

                <div className="d-grid d-md-flex justify-content-md-end mt-5">
                  <button
                    className="btn btn-primary btn-lg px-5 shadow-sm fw-bold"
                    onClick={handleRetornar}
                  >
                    Manifestar CIENTE e ir para Login
                  </button>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;